import { generatePathFromPoints } from '../../../../../utilities/PathGenerator/PathGenerator';
import getPoints from './points';

const getPath = shape => generatePathFromPoints(getPoints(shape));

export default getPath;
